import { render, staticRenderFns } from "./CiTable.vue?vue&type=template&id=6a95a122&"
import script from "./CiTable.vue?vue&type=script&lang=js&"
export * from "./CiTable.vue?vue&type=script&lang=js&"
import style0 from "./CiTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports